import styled from "styled-components";

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const Content = styled.div`
  width: 100%;
  min-height: 100vh;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: flex-start;

  padding: 24px 16px;
  border-radius: 12px;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  img {
    width: 40%;
    margin-bottom: 14px;
    max-width: 280px;
  }

  iframe {
    align-self: center;
    height: 50vh;
    width: 100%;
    max-width: 990px;
  }
`;

export const Title = styled.p`
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: ${({ marginBottom }) => marginBottom || "4px"};
  text-align: ${({ align }) => align || "left"};
  color: ${({ color }) => color || "inherit"};
`;

export const Subtitle = styled.span`
  width: 100%;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: ${({ marginBottom }) => marginBottom || "24px"};
  text-align: ${({ align }) => align || "left"};
  color: ${({ color }) => color || "#8E8E8E"};
`;


export const Main = styled.div`
  width: 80%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 24px;
`;